module.exports = __webpack_public_path__ + "img/EMT-CRC_CRLM.0f5445dc.png";